<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="panel-body info">
        <div class="row">
            <div class="btn-group pull-right document-action">
              <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" class="btn btn-sm btn-info dropdown-toggle"> Save to Biblio </button>
              <ul class="dropdown-menu dropdownCopyBox" aria-labelledby="dropdownCopy" style="z-index: 999999; min-width: 250px" >
                <template v-if="biblioBoxes.length">
                  <div class="dropdownCopyBoxList">
                    <li style="width: 100%; padding: 5px 5px" > Add to existing Box :</li>
                    <li v-for="box in biblioBoxes" :key="box.key" style="width: 100%; padding: 5px 5px"><a href="#" @click="onClick('saveTo',$event)" class="li-copyToBox text-info" :data-targetBox="box.name">{{box.name}} </a></li>
                  </div>
                </template>
                <li role="separator" class="divider"></li>
                <li style="width: 100%; padding: 5px 5px" ><a href="#" @click="addKeyword" style="color:#3498db"> <i class="fa fa-plus"></i>  Add  to new box ... </a></li>
              </ul>
            </div>
          <div class="clearfix"></div>
        </div>
        <blockquote v-if="aichat" v-html="aichat" style="white-space: pre-line;font-size: 13px;" />
        <template v-else >
          <i class="fa fa-exclamation-triangle fa-1x"></i> The service is temporarily limited, sorry for the inconvenience.
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0;
}
.dropdownCopyBoxList{
  max-height: 370px;
  overflow: hidden;
  overflow-y: scroll;
  padding-left: 20px;
}

.li-copyToBox {
  display: block;
  width: 80%;
  margin-left: 10px;
  padding: 2px 5px;
}

.li-copyToBox:hover {
  background-color: #f5f5f5;
}
</style>
<script>

export default {
  props: ['result', 'type', 'listId',
    'context', 'biblio', 'searchState', 'listType', 'searchType', 'project'],
  name: 'ListAI',
  data () {
    return {
      aichat: '',
      aichatComment: '',
      showTexteBiblio: 'default'
    }
  },
  computed: {
    biblioBoxes: function () {
      let content = this.biblio && this.biblio.content ? JSON.parse(this.biblio.content) : {}
      let boxes = []
      Object.values(content).forEach((box) => {
        boxes.push({key: box.key, name: box.name})
      })
      boxes.sort(function (boxe1, boxe2) {
        if (boxe1.name.toUpperCase() < boxe2.name.toUpperCase()) return -1
        if (boxe1.name.toUpperCase() > boxe2.name.toUpperCase()) return 1
        return 0
      })
      return boxes
    }
  },
  methods: {
    onClick: function (action, event) {
      switch (action) {
        case 'saveTo':
          if (this.aichatComment) {
            this.context.addAiChatToBiblio(this.aichatComment, event.target.dataset.targetbox)
          }
      }
      event.stopPropagation()
      event.preventDefault()
    },
    addKeyword: function (e) {
      this.showModalAddKeyword()
      e.preventDefault()
      e.stopPropagation()
    },
    showModalAddKeyword: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.showTexteBiblio = 'boxWithComment'
        $('#modalAddKeyword').modal('show')
        this.$eventHub.$emit('addKwdWithComment', this.aichatComment)
        this.$eventHub.$emit('showTexte', this.showTexteBiblio)
      }
    }
  },
  beforeMount () {
    this.aichatComment = 'Question : ' + this.$route.params.query + '. \n Answer : ' + this.result[0].aichat + '\n'
    this.aichat = this.result[0].aichat
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAI/ListAI.vue